"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Laptop = function Laptop(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M19.816 17.944H4.19a.937.937 0 01-.938-.938c0-.172.14-.312.313-.312h1.562V7.631c0-.862.7-1.562 1.563-1.562h10.625c.863 0 1.562.7 1.562 1.563v9.062h1.563c.172 0 .312.14.312.313 0 .517-.42.937-.937.937zM17.628 7.631a.312.312 0 00-.312-.312H6.69a.313.313 0 00-.313.313v7.812c0 .173.14.313.313.313h10.625c.172 0 .312-.14.312-.313V7.631z"
  }));
};

var _default = (0, _react.forwardRef)(Laptop);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Laptop, "Laptop", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Laptop.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Laptop.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9MYXB0b3AudHN4Il0sIm5hbWVzIjpbIkxhcHRvcCIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxNQUFzRSxHQUFHLFNBQXpFQSxNQUF5RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUM3RTtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQUQ2RTtBQUFBLENBQS9FOztlQVNlLHVCQUFXRixNQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLE0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IExhcHRvcDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTkuODE2IDE3Ljk0NEg0LjE5YS45MzcuOTM3IDAgMDEtLjkzOC0uOTM4YzAtLjE3Mi4xNC0uMzEyLjMxMy0uMzEyaDEuNTYyVjcuNjMxYzAtLjg2Mi43LTEuNTYyIDEuNTYzLTEuNTYyaDEwLjYyNWMuODYzIDAgMS41NjIuNyAxLjU2MiAxLjU2M3Y5LjA2MmgxLjU2M2MuMTcyIDAgLjMxMi4xNC4zMTIuMzEzIDAgLjUxNy0uNDIuOTM3LS45MzcuOTM3ek0xNy42MjggNy42MzFhLjMxMi4zMTIgMCAwMC0uMzEyLS4zMTJINi42OWEuMzEzLjMxMyAwIDAwLS4zMTMuMzEzdjcuODEyYzAgLjE3My4xNC4zMTMuMzEzLjMxM2gxMC42MjVjLjE3MiAwIC4zMTItLjE0LjMxMi0uMzEzVjcuNjMxelwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKExhcHRvcCk7XG4iXX0=